import { MenuItem, Select, Stack, Switch, Typography } from "@mui/material";
import type { FilterWidgetSettings } from "../../../../../../api/types/dashboardsTypes";
import { FilterComponentType } from "../../../../../../api/types/dashboardsTypes";
import { getTextFilterGrouping } from "../../../../reporting/sv/components/viewer/common/conditions/text-filter-grid-with-lazyloading/textFilterGrouping";
import type { DashboardFilter } from "../../../dashboard.types";

interface Props {
  filter: DashboardFilter | null;
  settings: FilterWidgetSettings;
  onSettingsChange: (settings: Partial<FilterWidgetSettings>) => void;
}

const FilterComponentTypeComponent = ({ filter, settings, onSettingsChange }: Props) => {
  if (!filter) {
    return null;
  }

  const isFilterTypeAvailable = filter.dataType === "text";
  const isGrouped =
    getTextFilterGrouping({
      isMultiBook: filter.isMultiBook,
      dimensionName: filter.id,
      keyFieldName: filter.valueField || "",
      books: filter.books,
    }) !== undefined;
  const isGridComponent =
    isFilterTypeAvailable &&
    !isGrouped &&
    (settings.componentType === FilterComponentType.List || settings.componentType === FilterComponentType.Dropdown);

  return (
    <Stack sx={{ gap: 1, width: "100%" }}>
      <Typography variant="subtitle2">Filter Type</Typography>
      <Select<FilterComponentType>
        value={settings.componentType}
        fullWidth
        disabled={!isFilterTypeAvailable}
        onChange={(e) => {
          onSettingsChange({
            componentType: e.target.value,
          });
        }}
      >
        <MenuItem value={FilterComponentType.Dropdown}>Dropdown</MenuItem>
        <MenuItem value={FilterComponentType.List}>List</MenuItem>
        <MenuItem value={FilterComponentType.Tile}>Tile</MenuItem>
      </Select>
      {!isGrouped && (
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1,
            justifyContent: "space-between",
            opacity: isFilterTypeAvailable ? 1 : 0.5,
          }}
        >
          <Typography variant="body1">Single Select</Typography>
          <Switch
            checked={settings.singleSelect}
            disabled={!isFilterTypeAvailable}
            onChange={(e) => onSettingsChange({ singleSelect: e.target.checked, defaultValue: [] })}
          />
        </Stack>
      )}
      {isGridComponent && (
        <Stack direction="row" sx={{ alignItems: "center", gap: 1, justifyContent: "space-between" }}>
          <Typography variant="body1">Hide Secondary Column</Typography>
          <Switch
            checked={settings.hideSecondaryColumn === true}
            onChange={(e) => onSettingsChange({ hideSecondaryColumn: e.target.checked })}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default FilterComponentTypeComponent;
